import { Discipline } from '@brighterly/lib-core-types/discipline/enums'

import { useKidStore } from '@stores/kid'
import { useDisciplineStore } from '@stores/discipline'

import { useKidInCustomer } from '@hooks/kid/kid-in-customer.hook'
import { useMiddlewareDisciplineInfo } from '@composables/middleware/discipline-info.hook'

export default defineNuxtRouteMiddleware(() => {
  const kidStore = useKidStore()
  const {
    kid,
  } = useKidInCustomer({ kidId: kidStore.activeKidId! })

  const disciplines = kid.value?.disciplines || []
  const disciplineMath = disciplines.find(discipline => discipline.code === Discipline.Math)

  const store = useDisciplineStore()
  store.setActiveDiscipline(disciplineMath || null)

  useMiddlewareDisciplineInfo()
})
